import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Terminal } from "lucide-react";
import { useAuth, formatApiError } from "../lib/auth";
import { Seo } from "../components/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full px-4 py-2.5 rounded bg-deep border border-white/10 text-white text-xs font-mono focus:outline-none focus:border-cyber";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-20 bg-deep" data-testid="login-page">
      <Seo title="Owner Login — oVu Cyber" description="Owner login for the oVu Cyber portfolio workspace." noindex />
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Terminal className="w-8 h-8 text-cyber mx-auto mb-3" />
          <h1 className="font-display text-2xl text-white font-bold uppercase">Owner Login</h1>
          <p className="font-mono text-xs text-dim mt-2">$ sudo access ~/admin</p>
        </div>
        <form onSubmit={submit} className="space-y-4 p-8 rounded-xl bg-panel border border-white/10" data-testid="login-form">
          {error && (
            <div className="p-3 rounded bg-red-500/10 border border-red-500/40 font-mono text-xs text-red-400" data-testid="login-error">
              {error}
            </div>
          )}
          <div>
            <label htmlFor="login-email" className="block font-mono text-xs text-dim mb-1">Email</label>
            <input id="login-email" type="email" required autoComplete="username" value={email}
              onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" />
          </div>
          <div>
            <label htmlFor="login-password" className="block font-mono text-xs text-dim mb-1">Password</label>
            <input id="login-password" type="password" required autoComplete="current-password" value={password}
              onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" />
          </div>
          <button type="submit" disabled={busy}
            className="w-full px-6 py-3 rounded bg-cyber text-[#0b0f19] font-bold text-xs font-mono uppercase tracking-wider hover:bg-white transition-colors disabled:opacity-50"
            data-testid="login-submit-button">
            {busy ? "Authenticating..." : "[ Enter Workspace ]"}
          </button>
        </form>
        <p className="text-center font-mono text-[11px] text-dim mt-6">
          Not the owner? <Link to="/" className="text-cyber hover:underline" data-testid="login-back-home-link">Back to the portfolio</Link>
        </p>
      </div>
    </div>
  );
}
